import { runInAction } from "mobx"

export interface StoreResults {
    passed: boolean
    message: string
    entityId?: string
    entities?: any
}

// Similar to StoreResults - but can be used when you know the return type of entities
// There is no validation here, so ensure the types match expected signature from backend!
export interface StoreResultsGeneric<T> {
    passed: boolean
    message: string
    entityId?: string
    entities?: T
}

export function returnOnCatch(error: unknown) {
    console.error("Error Delete entity:", error)
    return { passed: false, message: "An error has occurred, please check the logs", entityId: "" }
}

export function returnOnFail() {
    const message = "An error has occurred, please check the logs"
    return { passed: false, message, entityId: "" }
}

export const isSuccess = (code: number) => code >= 200 && code < 300

/**
 * Generic wrapper to handle loading state in MobX stores.
 * @param setLoading - setter function (typically: () => this.loading = true/false)
 * @param fn - the async function to run with loading state
 */
export async function withLoading<T>(setLoading: (value: boolean) => void, fn: () => Promise<T>): Promise<T> {
    setLoading(true)
    try {
        return await fn()
    } catch (error) {
        console.error("Error in withLoading wrapper:", error)
        throw error
    } finally {
        runInAction(() => setLoading(false))
    }
}
